import { useNavigate } from 'react-router-dom';
import { MenuCard } from '@runway/devkit';
import { FC } from 'react';

export const MosaicSelfServeCard: FC = () => {
  const navigate = useNavigate();

  return (
    <MenuCard
      title="Mosaic Self Serve"
      subtitle="Self-service options for Mosaic access"
      onButtonClick={() => navigate('/dataanalytics/mosaic-self-serve')}
      buttonText="Open"
    />
  );
};
